import React,{useEffect} from 'react'
import NavBar from '../components/NavBar'
import Image from '../assets/images/hero-illustration.svg'
import resume from  '../assets/images/resume-illustration.svg'
import BioData from '../components/BioData'
import OurWork from  '../components/OurWork'
import Contact from '../components/Contact'
import Footer from '../components/Footer'
import ParticleBackground from '../libraries/ParticleJS/particle_Background'
import {motion,LazyMotion,domAnimation,useAnimation} from 'framer-motion'
import {useInView} from 'react-intersection-observer'
import AnimatedText from 'react-animated-text-content'
import {HashLink} from 'react-router-hash-link'
// import Scroll from 'react-scroll'

const stats=[
  {value:"4+",label:"Years Experience"},
  {value:"3",label:"Client Products"},
  {value:"Millions",label:"Records Handled"},
  {value:"Level 1",label:"Fiverr Seller"},
]

const services=[
  {
    title:"Full Stack Development",
    text:"Production web applications and product features built with TypeScript, Node.js, Express, NestJS, React and Next.js, with REST and GraphQL APIs."
  },
  {
    title:"Backend & Data Engineering",
    text:"Schema design, indexing and query optimization on PostgreSQL and MongoDB, Redis caching, and ingestion, ETL and data-validation workflows for large datasets."
  },
  {
    title:"Cloud & DevOps",
    text:"Deployments on AWS (EC2, ECS, RDS, S3) with Docker, Linux, Nginx, PM2 and CI/CD, plus load balancing and production troubleshooting."
  },
  {
    title:"AI & Voice Agents",
    text:"Voice AI agents on Retell AI, conversational AI integrations with the OpenAI API and Claude, and workflow automation with n8n, APIs and webhooks."
  },
]

const experience=[
  {
    title:"Team Lead & Senior Software Engineer",
    meta:"DataZoro | Remote | Sep 2023 – Present",
    text:"Lead engineering delivery across long-term SaaS and data-platform products: architecture, implementation, code review, troubleshooting and production operations, across Node.js/TypeScript, React/Next.js, PostgreSQL, Redis and AWS.",
    projects:[
      {
        name:"Transparent California, Transparent Nevada & Nevada Policy (USA)",
        text:"Searchable public-pay and pension data platforms handling millions of structured records, their CRM systems and the Nevada Policy public website. Data ingestion, bulk-upload validation, PostgreSQL search performance and AWS-hosted production services."
      },
      {
        name:"Noramark (USA)",
        text:"AI-powered industrial sourcing and manufacturing platform connecting industrial buyers with verified domestic machine shops. Full-stack work across ERP, CRM, MRP, sourcing workflows and sales pipelines."
      },
    ]
  },
  {
    title:"Voice AI & Automation Engineer",
    meta:"NumbTec | Voice AI Agents product",
    text:"Build, configure and deploy voice agents on Retell AI for 24/7 call handling, customer support, appointment setting and phone reception, including call flows, prompts and integrations with CRM systems and business tools."
  },
]

const certifications=[
  "Meta Professional Frontend Developer Certification",
  "Meta React Native Professional Certification",
  "Fiverr Level 1 Seller — Automation & Full Stack",
]

const Home=(props)=>{
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("hidden");
    } else {
      control.start("visible");
    }
  }, [control, inView]);
  useEffect(()=>{
    const prevTitle = document.title;
    document.title = prevTitle + "- Senior Software Engineer & Team Lead"
    return ()=>{document.title = prevTitle}
  },[])

  const boxVariant={
    visible:{opacity:0}
    ,hidden:{opacity:1}
  }
  const ImgVariant={
    visible:{opacity:0,y:'-90vh'},
    hidden:{opacity:1,y:0}
  }
  
    return<>
        <ParticleBackground />
        <NavBar />  
        <LazyMotion features={domAnimation}>
        <motion.div 
    transition={{duration:1}}
    ref={ref}
    initial="hidden"
      variants={boxVariant}
     animate={control}
     >
        <div className="">
        <section className="text-gray-600 body-font">
            <div className="container md:w-[90%] w-[90%] px-5 mx-auto flex lg:py-20 md:py-20 sm:py-4 md:flex-row flex-col items-center">
                <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                <p className="mb-4 text-yellow-400 drop-shadow-sm leading-relaxed">SENIOR SOFTWARE ENGINEER &amp; TEAM LEAD</p>
              <AnimatedText
                 type='words'
                 interval={0.04}
                 duration={2}
                 animationType="float"
                 animation={{
                   y: '200px',
                   ease: 'ease',
                 }}
                 className="text-shadow-lg title-font xl:text-6xl text-5xl md:text-5xl mb-8 font-bold text-gray-900"
                 tag='h1'
              >
                MUHAMMAD REHAN
              </AnimatedText>
                
             <p className="mb-12 leading-relaxed text-base">
             I'm a Senior Software Engineer and Team Lead with 4+ years of experience building and scaling production web platforms, enterprise workflows, data-intensive systems and AI-enabled applications. I work remotely with U.S.-based products and stakeholders.
                </p>
                    <div className="flex justify-center">
                    <motion.div whileHover={{ scale: 1.2 }} >
                    <HashLink to="/#contact" className="inline-flex hover:bg-gradient-to-l bg-gradient-to-r from-[#fde801] to-[yellow] border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 text-lg">HIRE ME</HashLink>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.2 }} >
                    <a href="https://drive.google.com/file/d/1wkG6GXUIOPWOZK5WEqwbazdg7xEUUsFK/view?usp=sharing" target="_blank" rel='noreferrer' className="ml-4 inline-flex text-gray-700 bg-gray-200 border-0 py-2 px-6 focus:outline-none hover:bg-gradient-to-r from-slate-300 text-lg">DOWNLOAD CV</a>
                    </motion.div>
                </div>
            </div>
            <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6"> 
            <motion.div
    transition={{type:'spring',stiffness:120,default: { duration: 1 }}}
    ref={ref}
    variants={ImgVariant}
    initial="hidden"
     animate={control}
     >      
                <img className="object-cover object-center rounded w-full" alt="code editor with database, cloud, metrics and voice AI cards" src={Image} />
                </motion.div>
            </div>
            </div>
        </section>
</div>
        </motion.div>
       <BioData />
<OurWork />
<section className="text-gray-600 body-font bg-[yellow]">
  <div className="container md:w-[90%] w-[90%] px-5 py-24 mx-auto">
    <div className="flex flex-wrap -m-4 text-center">
      {stats.map((stat)=>(
      <div className="p-4 sm:w-1/4 w-1/2" key={stat.label}>
        <h2 className="title-font font-medium sm:text-4xl text-3xl text-gray-900">{stat.value}</h2>
        <p className="leading-relaxed">{stat.label}</p>
      </div>
      ))}
    </div>
  </div>
</section>
{/* My Services */}
<section className="text-gray-600 body-font" id='services'>
  <div className="container md:w-[90%] w-[90%] px-5 lg:py-24 py-8 mx-auto">
    <div className="flex flex-col w-full mb-10">
      <h1 className="sm:text-5xl text-4xl font-medium title-font mb-4 text-gray-900">
        What I Do
      </h1>
      <div className=" w-24 sm:h-1 md:h-2  my-4 rounded-full sm:mt-0 inline-flex bg-gradient-to-r from-yellow-300 to-yellow-400 text-white relative z-10 title-font font-medium text-sm ">
      </div>
      <p className="lg:w-2/3 leading-relaxed text-base">I build, scale and run production software for long-term products: full-stack features, backend services, database workflows and cloud deployments, with AI integrations where they are useful. To discuss a role or a project, email <a className='font-bold text-yellow-500' href="mailto:raorehanweb@gmail.com">raorehanweb@gmail.com</a> or <HashLink className='font-bold text-yellow-500' to="/#contact">contact me</HashLink>.</p>
    </div>
    <div className="grid gap-6 md:grid-cols-2">
      {services.map((service,index)=>(
      <div className={`${index%3===0 ? 'bg-yellow-100':'bg-white'} rounded-2xl shadow-xl px-8 py-12 sm:px-12 lg:px-8`} key={service.title}>
        <div className="space-y-4">
          <h3 className="text-2xl font-semibold text-yellow-500">{service.title}</h3>
          <p>{service.text}</p>
        </div>
      </div>
      ))}
    </div>
  </div>
</section>

{/*My Resume*/}
<section className="text-gray-600 body-font">
  <div className="container md:w-[80%] w-[90%] px-5 py-24 mx-auto flex flex-wrap">
    <div className="lg:w-1/2 w-full mb-10 lg:mb-0">
      <img alt="resume illustration" className="object-contain object-center w-full lg:max-h-[640px] lg:sticky lg:top-24" src={resume} />
    </div>
    <div className="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
    <div className="flex flex-col w-full mb-5">
      <h1 className="sm:text-5xl text-4xl font-medium title-font mb-4 text-gray-900">
        Resume
      </h1>
      <div className=" w-24 sm:h-1 md:h-2  my-2 rounded-full sm:mt-0 inline-flex bg-gradient-to-r from-yellow-300 to-yellow-400 text-white relative z-10 title-font font-medium text-sm ">
      </div>
      <h1 className="sm:text-2xl text-4xl font-medium title-font mb-2 text-gray-900">
        My Work Experience
      </h1>
    </div>
      {experience.map((job)=>(
      <div className="flex flex-col mb-10 lg:items-start items-center" key={job.title}>
        <div className="flex-grow">
          <h2 className="text-gray-900 text-lg title-font font-medium">{job.title}</h2>
          <p className="text-sm font-bold text-yellow-500 mb-3">{job.meta}</p>
          <p className="leading-relaxed text-base mb-3">{job.text}</p>
          {job.projects && job.projects.map((project)=>(
          <p className="leading-relaxed text-base mb-3" key={project.name}><span className="font-medium text-gray-900">{project.name}:</span> {project.text}</p>
          ))}
          <hr/>
        </div>
      </div>
      ))}
      <div className="flex flex-col w-full mb-5">
      <h1 className="sm:text-2xl text-4xl font-medium title-font mb-2 text-gray-900">
        Education
      </h1>
    </div>
      <div className="flex flex-col mb-10 lg:items-start items-center">
        <div className="flex-grow">
          <h2 className="text-gray-900 text-lg title-font font-medium mb-3">BS Software Engineering (2024)</h2>
          <p className="leading-relaxed text-base">
          National University of Modern Languages (NUML), Islamabad, Pakistan
          </p>
          <hr/>
        </div>
      </div>
      <div className="flex flex-col w-full mb-5">
      <h1 className="sm:text-2xl text-4xl font-medium title-font mb-2 text-gray-900">
        Certifications
      </h1>
    </div>
      <div className="flex flex-col mb-10 lg:items-start items-center">
        <div className="flex-grow">
          {certifications.map((certification)=>(
          <p className="leading-relaxed text-base" key={certification}>{certification}</p>
          ))}
          <hr/>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="text-gray-600 bg-[yellow] body-font">
  <div className="container px-5 py-24 mx-auto">
    <div className="flex flex-col text-center w-full mb-12">
      <h1 className="sm:text-3xl lg:text-6xl font-medium title-font mb-4 text-gray-900">
        Let's <span className='text-black'>Work</span> Together
      </h1>
      <p className="lg:w-2/3 mx-auto leading-relaxed text-base">I work remotely with U.S.-based products and stakeholders. If you need a senior engineer for a platform, a data system or an AI integration, get in touch.</p>
    </div>

  <div className="container px-5 mx-auto">
  <motion.div whileHover={{ scale: 1.2 }} >

  <HashLink to="/#contact">
  <button className="flex mx-auto mt-10 text-center text-black bg-gradient-to-r from-[#fde801] to-yellow-400 border-0 py-2 px-8 focus:outline-none shadow-lg hover:bg-indigo-600 text-lg">HIRE ME
  </button>
  </HashLink>
  </motion.div>
  </div>
  </div>
</section>
<Contact />
<Footer />
</LazyMotion>
    </>
}

export default Home;